module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("0jm5k"))).then(() => parcelRequire('ljYL6'));